module.exports = __webpack_public_path__ + "static/media/copy.92f62803.svg";